<template>
  <span v-if="timeAgo.type == 'date'">{{
    $d(timeAgo.date, timeAgo.thisYear ? 'short-wo-year' : 'short-w-year')
  }}</span>
  <span v-else-if="timeAgo.type == 'yesterday'"
    >{{
      $t('components.timeAgo.' + timeAgo.type, {
        count: timeAgo.count,
      })
    }}
  </span>
  <span v-else-if="timeAgo.type == 'second'">{{ $t('components.timeAgo.now') }} </span>
  <span v-else
    >{{
      $t('components.timeAgo.ago', {
        time: $t('components.timeAgo.' + timeAgo.type, {
          count: timeAgo.count,
        }),
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
  date: string
}

interface TimeAgo {
  type: 'second' | 'minute' | 'hour' | 'day' | 'date' | 'yesterday'
  count: number
  date: Date
  thisYear: boolean
}

const props = defineProps<Props>()

const maxNumberOfDays = 4

const timeAgo = computed(() => {
  return timeSince(props.date)
})

const timeSince = (date: string): TimeAgo => {
  const seconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000)
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)

  const actualDate = new Date(date)

  const thisYear = actualDate.getUTCFullYear() === today.getUTCFullYear()

  if (
    actualDate.getDate() === yesterday.getDate() &&
    actualDate.getMonth() === yesterday.getMonth() &&
    actualDate.getFullYear() === yesterday.getFullYear()
  ) {
    return { type: 'yesterday', date: actualDate, count: 1, thisYear: thisYear }
  }

  let interval = seconds / 31536000

  //   if (interval > 1) {
  //     return Math.floor(interval) + ' years'
  //   }
  //   interval = seconds / 2592000
  //   if (interval > 1) {
  //     return Math.floor(interval) + ' months'
  //   }
  interval = seconds / 86400
  if (interval > 1) {
    if (interval > maxNumberOfDays) {
      return { type: 'date', date: actualDate, count: 1, thisYear: thisYear }
    }
    return {
      type: 'day',
      count: Math.ceil(interval),
      date: actualDate,
      thisYear: thisYear,
    }
  }
  interval = seconds / 3600
  if (interval > 1) {
    return {
      type: 'hour',
      count: Math.ceil(interval),
      date: actualDate,
      thisYear: thisYear,
    }
  }
  interval = seconds / 60
  if (interval > 1) {
    return {
      type: 'minute',
      count: Math.ceil(interval),
      date: actualDate,
      thisYear: thisYear,
    }
  }
  return {
    type: 'second',
    count: Math.ceil(interval),
    date: actualDate,
    thisYear: thisYear,
  }
}
</script>
